document.addEventListener('DOMContentLoaded',()=>{
  const header=document.querySelector('.cron-header');
  const toggle=header?.querySelector('[data-cron-menu-toggle]');
  const project=header?.querySelector('.cron-project-nav');
  const mobile=window.matchMedia('(max-width:990px)');
  const closeMenu=()=>{header?.classList.remove('is-open');toggle?.setAttribute('aria-expanded','false');if(project)project.open=false;};
  toggle?.addEventListener('click',()=>{const open=!header.classList.contains('is-open');closeMenu();header.classList.toggle('is-open',open);toggle.setAttribute('aria-expanded',String(open));});
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;if(project?.open){project.open=false;project.querySelector('summary')?.focus();}else if(header?.classList.contains('is-open')){closeMenu();toggle?.focus();}});
  document.addEventListener('click',event=>{if(header&&!header.contains(event.target))closeMenu();else if(project&&!project.contains(event.target))project.open=false;});
  header?.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
  header?.addEventListener('focusout',event=>{if(event.relatedTarget&&!header.contains(event.relatedTarget))closeMenu();});
  mobile.addEventListener('change',closeMenu);
  const current=new URL(window.location.href);
  const pageKey=url=>url.searchParams.get('view')?.replace(/^preview-/,'')||url.pathname.replace(/^\/pages\//,'').replace(/\/$/,'');
  const currentKey=pageKey(current);
  const filmKeys=['stereo','crimes-1970','shivers','rabid','brood','scanners','videodrome','fly','dead-ringers','naked-lunch','crash','existenz','crimes-2022','shrouds'];
  header?.querySelectorAll('.cron-nav a').forEach(link=>{
    const url=new URL(link.href,current);const key=pageKey(url);
    if(!url.hash&&key===currentKey&&key){link.setAttribute('aria-current','page');link.classList.add('is-current-section');}
    if(key==='archive'&&filmKeys.includes(currentKey))link.classList.add('is-current-section');
    if(link.hasAttribute('aria-current')&&project?.contains(link))project.classList.add('is-current-section');
  });
  function refreshCases(){
    document.querySelectorAll('[data-case-preview]').forEach(grid=>{
      const all=Array.from(grid.querySelectorAll('[data-case-card]'));
      const cards=all.filter(card=>card.dataset.caseStatus==='available');
      all.forEach(card=>{card.hidden=true;});
      for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}
      cards.forEach((card,i)=>{card.hidden=i>=4;grid.appendChild(card);});
    });
  }
  refreshCases();
  window.addEventListener('pageshow',event=>{if(event.persisted){closeMenu();refreshCases();}});
  document.addEventListener('shopify:section:load',refreshCases);
});
